import { create } from 'zustand';

interface CompleteEncModalStore {
  isOpen: boolean;
  encId: number;
  onCompleteEncClose: () => void;
  onCompleteEncOpen: (encId: number) => void;
}

export const useCompleteEncModalStore = create<CompleteEncModalStore>(set => ({
  isOpen: false,
  encId: 0,
  onCompleteEncClose: () => set({ isOpen: false, encId: 0 }),
  onCompleteEncOpen: (encId: number) => set({ isOpen: true, encId }),
}));
